import { useReact19UniqueKeyCompatibility } from '@/hooks/use-react19-unique-key-compatibility';
import { DS_FONT_SIZE, PRIMITIVES } from '@calm/evexia-design-tokens';
import { ChLink } from '@rhg/components/ch-link';
import registrationMessages from '@rhg/lang/messages/registration';
import { Stack, Box, Typography } from '@rhg/libs/material';
import { WarningWithCircleBackgroundWhite } from '@rhg/libs/material/icons/warning-with-circle-background-white';
import { calmSupportEmail } from '@rhg/utils/constants';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';

const wrapper = {
    pt: 12,
};

const descriptionBox = {
    width: { xs: '85%', md: '40%' },
};

const mobileHeadingStyle = {
    mb: 4,
    fontSize: { xs: PRIMITIVES.typography.size._24, md: DS_FONT_SIZE.H4 },
};

const mobileTextStyle = {
    fontSize: {
        xs: PRIMITIVES.typography.size._16,
        md: DS_FONT_SIZE.NORMAL_LARGE,
    },
};

function SsoSponsorshipError() {
    const { formatMessage } = useIntl();
    const { wrapNodesWithKeys } = useReact19UniqueKeyCompatibility();

    return (
        <Stack sx={wrapper} alignItems="center" gap={4}>
            <WarningWithCircleBackgroundWhite sx={{ mt: 12 }} />
            <Box sx={descriptionBox}>
                <Typography
                    color="text.body"
                    align="center"
                    variant="h4"
                    component="h1"
                    sx={mobileHeadingStyle}
                >
                    {formatMessage(
                        registrationMessages[
                            'registration.join_sponsorship_failure.header'
                        ]
                    )}
                </Typography>
                <Typography
                    color="text.body"
                    align="center"
                    paragraph
                    sx={mobileTextStyle}
                >
                    {wrapNodesWithKeys(
                        formatMessage(
                            registrationMessages[
                                'registration.join_sponsorship_failure.subheader'
                            ],
                            {
                                SupportLink: (...chunks: ReactNode[]) => (
                                    <ChLink href={`mailto:${calmSupportEmail}`}>
                                        {chunks}
                                    </ChLink>
                                ),
                            }
                        )
                    )}
                </Typography>
            </Box>
        </Stack>
    );
}

export default SsoSponsorshipError;
